module.exports = __webpack_public_path__ + "distribution/img/mer.e81c2ae3.png";